import { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { useNavigate } from 'react-router';

import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, InputBase, InputLabel, MenuItem, Paper, Radio, RadioGroup, Select, TextField } from '@mui/material';

import moment from 'moment';

import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SearchIcon from '@mui/icons-material/Search';

import { RootState } from '../store';

import { DialogNuevaPersona } from './DialogNuevaPersona';
import { DialogBuscarPersona } from './DialogBuscarPersona';

import { InputSearchButtonsStyle, InputSearchStyle } from '../styles/FormStyle';
import { DialogActionsStyle, DialogContentStyle } from '../styles/DialogStyle';

import { ObtenerTipoTramites } from '../connections/catalogos/TipoTramiteConnection';

import { NuevaRecepcion } from '../connections/comun/RecepcionConnection';

import { PresentanteProps } from '../interfaces/comun/PersonaInterface';
import { TipoTramiteProps } from '../interfaces/catalogos/TipoTramiteInterface';
import { NuevaRecepcionParams } from '../interfaces/comun/RecepcionInterface';

interface Props {
    openDialog:          boolean;
    handleCloseDialog:   () => void;
}

interface Error {
    descripcion?:   string;
}

export const DialogNuevaRecepcion = ( { openDialog, handleCloseDialog }: Props ) => {

    const navigate = useNavigate();

    const { turno } = useSelector( ( state: RootState ) => state.turno );

    const DateNow = moment( new Date()).format("YYYY-MM-DDTHH:mm");

    const [openDialogNuevaPersona, setopenDialogNuevaPersona] = useState(false);
    
    const [openDialogBuscarPersona, setopenDialogBuscarPersona] = useState(false);

    const [presentante, setPresentante] = useState<PresentanteProps>( { idPersona: 0, nombreCompleto: '' } );

    const { idPersona, nombreCompleto } = presentante;
    
    const [tipoTramite, setTipoTramite] = useState( 0 );
    const [tipoTramiteArray, setTipoTramiteArray] = useState<TipoTramiteProps[]>( [] );

    const [fechaReloj, setFechaReloj] = useState( DateNow );
    const [recibidoReloj, setRecibidoReloj] = useState( false );
    
    const [loading, setLoading] = useState(false);

    const [recibidoPaqueteria, setRecibidoPaqueteria] = useState( false );

    const [errors, setErrors] = useState<Error>({ });

    const seleccionarPersona = ( persona: PresentanteProps ) => setPresentante( persona )

    const handleClose = () => {

        setTipoTramite( 0 );
        setRecibidoReloj( false );
        setRecibidoPaqueteria( false );
        setPresentante( { idPersona: 0, nombreCompleto: '' } );
        setErrors( {} );
        
        handleCloseDialog();

    }

    const GenerarRecepcion = async () => {

        setLoading( true );

        const params: NuevaRecepcionParams = {
            idPresentante: idPersona,
            idTipoTramite: tipoTramite,
            recibidoPorReloj: recibidoReloj,
            fechaReloj: fechaReloj,         
            recibidoPaqueteria: recibidoPaqueteria,
            idTurno: turno.turno_id === 0 ? 1 : turno.turno_id,
            turno: {
                idTurno: turno.turno_id,
                numeroTurno: turno.turno_numero,
                fecha: turno.turno_fecha,
                numeroTelefono: turno.turno_telefono ?? '',
            }
        };

        await NuevaRecepcion( params ).then( resp => {

           const { success, message, idRecepcion } = resp;

            if( success ){

                setTimeout(() => {
    
                    setLoading( false );

                    if( tipoTramite === 1 ){
                        navigate( `/recepcion/demanda-inicial/${ idRecepcion }` );
                    }
                    else if( tipoTramite === 2 ){
                        navigate( `/recepcion/promocion/${ idRecepcion }` );
                    }
                    else if( tipoTramite === 3 ){
                        navigate( `/recepcion/amparo/${ idRecepcion }` );
                    }
                    else if( tipoTramite === 4 ){
                        navigate( `/recepcion/exhorto-recibido/${ idRecepcion }` );
                    }

                    setLoading( false );
                    handleClose();

                }, 700);          

            }
            else {

                setErrors( { } );

                let errores: Error = { descripcion: message };

                setErrors( errores );

                setLoading( false );
            }          

        });
        
    }

    useEffect(() => {
        
        async function Obtener(){
            
            await ObtenerTipoTramites().then( resp => {  
                setTipoTramiteArray( resp );    
            });

        }

        Obtener();

    }, [ ]);
    
    return (
        <>
            <Dialog 
                open={ openDialog }          
                maxWidth='sm' 
            >

                <DialogTitle>
                    Nueva recepción
                </DialogTitle>
            
                <DialogContent sx={ DialogContentStyle }>

                    <Grid container spacing={3} mt={1}>

                        <Grid size={{ md: 12, xs: 12 }}>
                            <FormControl>
                                <FormLabel>¿El trámite es recibido por paquetería?</FormLabel>
                                <RadioGroup row>
                                    <FormControlLabel control={ <Radio checked={ recibidoPaqueteria === false } onChange={ ( e ) => { setRecibidoPaqueteria( false ); setPresentante({ idPersona: 0, nombreCompleto: '' }); } } />} label="No" />
                                    <FormControlLabel control={ <Radio checked={ recibidoPaqueteria === true } onChange={  ( e ) => { setRecibidoPaqueteria( true); setPresentante({ idPersona: 0, nombreCompleto: '' }); } } />} label="Si" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>

                        {
                            !recibidoPaqueteria
                            &&
                                <Grid size={{ md: 12, xs: 12 }} > 
                                
                                    <Paper component="div" sx={ InputSearchStyle } >                            
                                        
                                        <InputBase 
                                            sx={{ ml: 1, flex: 1 }} 
                                            inputProps={{ 'aria-label': 'Buscar presentante' }} 
                                            placeholder="Buscar presentante"     
                                            name="presentante"
                                            value={ nombreCompleto }   
                                            onChange={ () => {} }             
                                            autoComplete="off"   
                                            disabled
                                        /> 

                                        <Button 
                                            size='small'
                                            variant='contained' 
                                            sx={ InputSearchButtonsStyle } 
                                            disabled={ recibidoPaqueteria }
                                            onClick={ () => setopenDialogBuscarPersona( true ) }
                                        >
                                            <SearchIcon />
                                        </Button>         

                                        <Button 
                                            variant='contained' 
                                            size='small'
                                            sx={ InputSearchButtonsStyle } 
                                            disabled={ recibidoPaqueteria }
                                            onClick={ () => setopenDialogNuevaPersona( true ) }
                                        >
                                            <PersonAddIcon />
                                        </Button>         

                                    </Paper>        

                                </Grid>                      
                        }

                        <Grid size={{ md: 12, xs: 12 }} mt={ !recibidoPaqueteria ? 2 : 1 }>      

                            <FormControl fullWidth>
                                <InputLabel>Tipo de trámite</InputLabel>
                            
                                <Select                                                                          
                                    label="Tipo de trámite"
                                    value={ tipoTramite }
                                    onChange={ (e) => setTipoTramite( parseInt( e.target.value.toString() ?? '0' ) ) }                           
                                >
                                    <MenuItem value={0}>Selecciona una opción</MenuItem>
                                    {
                                        tipoTramiteArray.map( ({ idTipoTramite, descripcion }) => (
                                            <MenuItem key={idTipoTramite} value={idTipoTramite}>{ descripcion }</MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>
                            
                        </Grid> 

                        <Grid size={{ md: 6, xs: 12 }} mt={1}>

                            <FormControl>

                                <FormLabel>¿El trámite es recibido por reloj?</FormLabel>
                                <RadioGroup row>
                                    <FormControlLabel control={ <Radio checked={ recibidoReloj === true } onChange={  ( e ) => { setRecibidoReloj( true ); setFechaReloj( DateNow ); } } />} label="Si" />
                                    <FormControlLabel control={ <Radio checked={ recibidoReloj === false } onChange={ ( e ) => setRecibidoReloj( false ) } />} label="No" />
          
                                </RadioGroup>

                            </FormControl>
                            
                        </Grid>

                        <Grid size={{ md: 6, xs: 12 }} mt={2}>

                            {
                                recibidoReloj 
                                && 
                                    <TextField                              
                                        label="Fecha recibida por reloj"
                                        type="datetime-local"   
                                        name="fechaReloj"                             
                                        value={ fechaReloj }    
                                        onChange={ ( e ) => { setFechaReloj( e.target.value ); } }                                                     
                                        fullWidth       
                                    />                                 
                            }

                        </Grid>

                        {   
                            errors.descripcion && ( 
                                <Grid size={{ md: 12, xs: 12 }}>
                                    <Alert severity="error" variant="filled" > { errors.descripcion } </Alert> 
                                </Grid>
                            )
                        }    

                    </Grid>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button 
                        color="secondary" 
                        onClick={ handleClose }
                        disabled={ loading } 
                    >
                        Cancelar
                    </Button>
                    <Button 
                        variant="contained" 
                        color="primary"    
                        onClick={ GenerarRecepcion }
                        loading={ loading } 
                        disabled={ 
                            loading ||  
                            tipoTramite === 0 ||
                            ( !recibidoPaqueteria && idPersona === 0 ) ||
                            ( recibidoReloj && fechaReloj === '' )
                        } 
                    >
                        Guardar
                    </Button>
                </DialogActions>

            </Dialog>

            <DialogNuevaPersona 
                openDialog={ openDialogNuevaPersona } 
                handleCloseDialog={ () => setopenDialogNuevaPersona( false ) } 
                seleccionarPersona={ seleccionarPersona }
            />

            <DialogBuscarPersona
                openDialog={ openDialogBuscarPersona } 
                handleCloseDialog={ () => setopenDialogBuscarPersona( false ) } 
                seleccionarPersona={ seleccionarPersona }
            />

        </>
    )
}